import { render, staticRenderFns } from "./AppInfoManagement.vue?vue&type=template&id=afbc327c&scoped=true"
import script from "./AppInfoManagement.vue?vue&type=script&lang=js"
export * from "./AppInfoManagement.vue?vue&type=script&lang=js"
import style0 from "./AppInfoManagement.vue?vue&type=style&index=0&id=afbc327c&prod&scoped=true&lang=css"
import style1 from "./AppInfoManagement.vue?vue&type=style&index=1&id=afbc327c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbc327c",
  null
  
)

export default component.exports